import { render, staticRenderFns } from "./GeometryEditor.vue?vue&type=template&id=6aae6fdf&scoped=true&"
import script from "./GeometryEditor.vue?vue&type=script&lang=js&"
export * from "./GeometryEditor.vue?vue&type=script&lang=js&"
import style0 from "./GeometryEditor.vue?vue&type=style&index=0&id=6aae6fdf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae6fdf",
  null
  
)

export default component.exports